export interface NavItem {
  label: string;
  href: string;
}

export interface FlashItem {
  time: string;
  tag: string;
  title: string;
  heat: string;
}

export interface TopicItem {
  name: string;
  count: number;
  size: number;
}

export interface CoverFeature {
  tag: string;
  title: string;
  desc: string;
  meta: string;
  image: string;
}

export interface TimelineItem {
  date: string;
  title: string;
  desc: string;
  status: string;
}

export interface CollectionItem {
  no: string;
  title: string;
  count: string;
  desc: string;
  tags: string[];
}

export interface GalleryItem {
  caption: string;
  tag: string;
  image: string;
}

export interface RankingItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  trend: "up" | "flat" | "down";
}

export const navItems: NavItem[] = [
  { label: "今日速报", href: "#flash" },
  { label: "话题墙", href: "#topics" },
  { label: "封面专题", href: "#covers" },
  { label: "时间线", href: "#timeline" },
  { label: "合集索引", href: "#collections" },
  { label: "现场实拍", href: "#gallery" },
  { label: "热瓜榜单", href: "#ranking" },
];

export const marqueeItems: string[] = [
  "直播争议新进展：当事人评论区再回应",
  "代言风波反转：品牌方深夜删除合作内容",
  "活动生图流出，状态对比冲上热榜",
  "三年前旧采访被考古，一句话引爆话题",
  "多条爆料贴同时上线，事件升级为连锁话题",
  "工作室长文澄清时间线，网友逐条比对仍有疑点",
];

export const flashFeed: FlashItem[] = [
  { time: "09:42", tag: "塌房", title: "某综艺人气嘉宾被曝私下言论翻车，聊天记录连环放出", heat: "8.6万" },
  { time: "09:15", tag: "反转", title: "代言风波出现反转：品牌方深夜回应，评论区彻底吵翻", heat: "7.1万" },
  { time: "08:40", tag: "实拍", title: "线下活动生图流出，当事人状态与精修图差距引热议", heat: "6.4万" },
  { time: "08:05", tag: "旧账", title: "三年前旧采访被翻出，一句回答让话题再度冲上热搜", heat: "5.2万" },
  { time: "07:30", tag: "澄清", title: "工作室发长文澄清时间线，网友逐条比对后表示仍有疑点", heat: "4.8万" },
  { time: "06:50", tag: "联动", title: "多位博主接连下场，事件从单点爆料升级为连锁话题", heat: "3.9万" },
];

export const topicWall: TopicItem[] = [
  { name: "网红塌房", count: 1284, size: 5 },
  { name: "直播争议", count: 962, size: 4 },
  { name: "代言翻车", count: 815, size: 4 },
  { name: "生图实拍", count: 703, size: 3 },
  { name: "旧采访考古", count: 651, size: 3 },
  { name: "私信截图", count: 588, size: 3 },
  { name: "深夜长文", count: 512, size: 2 },
  { name: "反转现场", count: 476, size: 2 },
  { name: "综艺名场面", count: 421, size: 2 },
  { name: "联名风波", count: 388, size: 2 },
  { name: "素人爆料", count: 342, size: 1 },
  { name: "时间线复盘", count: 305, size: 1 },
];

export const coverFeatures: CoverFeature[] = [
  {
    tag: "深度合集",
    title: "从一条私信到全网对线：这波争议的完整来龙去脉",
    desc: "按时间顺序把爆料、回应、反转与二次发酵串成一条线，一条链接看完整个事件，不用再到处翻碎片信息。",
    meta: "共 12 条时间线 · 更新于今天 09:20",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20vintage%20film%20camera%20and%20scattered%20torn%20newspaper%20headlines%20on%20warm%20cream%20paper%2C%20bold%20crimson%20red%20accents%2C%20dramatic%20side%20lighting%2C%20abstract%20conceptual%20magazine%20art%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=800&height=600&seq=heiliaowang-cover-01&orientation=landscape",
  },
  {
    tag: "现场实拍",
    title: "活动生图 vs 精修图：同一晚的两套画风",
    desc: "把现场实拍和官方精修并排放，逐张标注差异点，顺手整理网友最常提到的几个讨论角度。",
    meta: "图集 18 张 · 含现场实拍细节标注",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20cracked%20mirror%20shards%20reflecting%20blurred%20anonymous%20figures%20on%20warm%20cream%20backdrop%2C%20crimson%20red%20and%20gold%20ink%2C%20dramatic%20moody%20lighting%2C%20conceptual%20editorial%20magazine%20art%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=800&height=600&seq=heiliaowang-cover-02&orientation=landscape",
  },
  {
    tag: "事件盘点",
    title: "今年被反复提起的 6 个吃瓜名场面",
    desc: "不追单一热点，直接把今年讨论度最高、被二创最多的事件挑出来，按影响范围重新排一遍。",
    meta: "盘点 6 个事件 · 附话题热度曲线",
    image:
      "https://readdy.ai/api/search-image?query=empty%20wooden%20chair%20under%20a%20single%20spotlight%20on%20warm%20cream%20stage%20floor%2C%20long%20dramatic%20shadow%2C%20crimson%20red%20curtain%20edge%2C%20conceptual%20editorial%20magazine%20art%2C%20minimal%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=800&height=600&seq=heiliaowang-cover-03&orientation=landscape",
  },
];

export const timeline: TimelineItem[] = [
  { date: "9月23日 · 09:42", title: "当事人聊天记录被公开", desc: "多张截图同时出现在不同账号，话题在半小时内冲上前列。", status: "进行中" },
  { date: "9月23日 · 08:18", title: "品牌方删除合作相关内容", desc: "官方账号悄悄下架近期联动物料，未发布任何文字说明。", status: "已确认" },
  { date: "9月22日 · 23:50", title: "工作室首次发声", desc: "发布简短声明，仅说明「正在核实」，未回应具体质疑点。", status: "已回应" },
  { date: "9月22日 · 21:05", title: "多条爆料贴同时上线", desc: "不同来源的信息在同一时段集中出现，事件讨论范围迅速扩大。", status: "已扩散" },
  { date: "9月22日 · 18:30", title: "活动现场生图流出", desc: "现场拍摄图被陆续上传，网友开始逐张对比状态与细节。", status: "已归档" },
  { date: "9月22日 · 12:00", title: "话题首次进入大众视野", desc: "最初只是小范围讨论，被搬运后热度快速抬升。", status: "起点" },
];

export const collections: CollectionItem[] = [
  { no: "01", title: "塌房现场合集", count: "48 条", desc: "聊天记录、生图与回应都往里放，按更新时间自动排在最前。", tags: ["聊天记录", "生图", "回应"] },
  { no: "02", title: "代言风波合集", count: "36 条", desc: "从官宣到下架，把品牌与当事人之间的动作节点整理清楚。", tags: ["品牌方", "下架", "声明"] },
  { no: "03", title: "综艺尴尬瞬间合集", count: "29 条", desc: "名场面被反复二创，这里收录原片片段与网友解读。", tags: ["名场面", "原片", "二创"] },
  { no: "04", title: "深夜长文回应合集", count: "25 条", desc: "把所有「小作文」按发布时间排好，方便逐条对照细节。", tags: ["长文", "时间线", "对照"] },
  { no: "05", title: "反转再反转合集", count: "22 条", desc: "专收剧情反复的事件，标注每一次反转的关键证据。", tags: ["反转", "证据", "复盘"] },
  { no: "06", title: "素人爆料上分合集", count: "18 条", desc: "普通人视角的现场描述与线索，往往比官方说法更有信息量。", tags: ["素人", "线索", "现场"] },
];

export const gallery: GalleryItem[] = [
  {
    caption: "活动现场外场，人群等待入场的瞬间",
    tag: "现场实拍",
    image:
      "https://readdy.ai/api/search-image?query=close-up%20of%20anonymous%20blurred%20silhouettes%20behind%20frosted%20glass%2C%20warm%20cream%20tones%20with%20crimson%20red%20glow%2C%20conceptual%20editorial%20photography%2C%20grainy%20print%20texture%2C%20abstract%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-01&orientation=squarish",
  },
  {
    caption: "被反复搬运的纸质线索，拼贴成时间墙",
    tag: "线索物料",
    image:
      "https://readdy.ai/api/search-image?query=scattered%20torn%20magazine%20paper%20strips%20on%20warm%20cream%20surface%2C%20gold%20and%20crimson%20ink%20stains%2C%20overhead%20flat%20lay%2C%20conceptual%20editorial%20art%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-02&orientation=squarish",
  },
  {
    caption: "话题升温当天的舆论氛围示意",
    tag: "氛围记录",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20smoke%20swirls%20over%20warm%20cream%20background%2C%20crimson%20red%20and%20dark%20shadow%20accents%2C%20dramatic%20moody%20lighting%2C%20conceptual%20editorial%20art%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-03&orientation=squarish",
  },
  {
    caption: "被逐帧分析的发言现场",
    tag: "原片截图",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20microphone%20on%20warm%20cream%20backdrop%20with%20crimson%20red%20light%20leak%2C%20conceptual%20editorial%20still%20life%2C%20grainy%20print%20texture%2C%20shallow%20depth%20of%20field%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-04&orientation=squarish",
  },
  {
    caption: "争议截图被放大比对后的细节示意",
    tag: "细节放大",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20shattered%20glass%20texture%20over%20warm%20cream%20and%20dark%20red%20gradient%2C%20conceptual%20editorial%20art%2C%20dramatic%20lighting%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-05&orientation=squarish",
  },
  {
    caption: "热搜当晚的直播间外景记录",
    tag: "外景记录",
    image:
      "https://readdy.ai/api/search-image?query=anonymous%20crowd%20silhouettes%20under%20warm%20tungsten%20light%20on%20cream%20background%2C%20crimson%20red%20highlights%2C%20conceptual%20editorial%20documentary%20art%2C%20grainy%20print%20texture%2C%20no%20readable%20text&width=600&height=600&seq=heiliaowang-gallery-06&orientation=squarish",
  },
];

export const ranking: RankingItem[] = [
  { rank: 1, title: "某综艺嘉宾言论翻车", category: "塌房", heat: "9862", trend: "up" },
  { rank: 2, title: "品牌方深夜回应风波", category: "代言", heat: "8730", trend: "up" },
  { rank: 3, title: "活动生图流出引对比", category: "实拍", heat: "7615", trend: "flat" },
  { rank: 4, title: "三年前采访被考古", category: "旧账", heat: "6908", trend: "up" },
  { rank: 5, title: "工作室长文澄清时间线", category: "澄清", heat: "6024", trend: "down" },
  { rank: 6, title: "多位博主接连下场对线", category: "联动", heat: "5488", trend: "up" },
  { rank: 7, title: "联名物料被连夜下架", category: "品牌", heat: "4930", trend: "flat" },
  { rank: 8, title: "素人现场目击描述流出", category: "素人", heat: "4201", trend: "up" },
];